import { render, staticRenderFns } from "./one2oneanswer.vue?vue&type=template&id=55d3eb52&scoped=true&"
import script from "./one2oneanswer.vue?vue&type=script&lang=js&"
export * from "./one2oneanswer.vue?vue&type=script&lang=js&"
import style0 from "./one2oneanswer.vue?vue&type=style&index=0&id=55d3eb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3eb52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d3eb52')) {
      api.createRecord('55d3eb52', component.options)
    } else {
      api.reload('55d3eb52', component.options)
    }
    module.hot.accept("./one2oneanswer.vue?vue&type=template&id=55d3eb52&scoped=true&", function () {
      api.rerender('55d3eb52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/one2oneanswer/one2oneanswer.vue"
export default component.exports